import React from "react";
import { Table } from "@skbkontur/staff-common";
import { Paging, Radio } from "@skbkontur/react-ui";

import { EmployerNormalizedTag, ImportEmployerDocumentsColumn } from "../../../EmployeeServiceTypes";
import { EMPLOYEE_DOCUMENTS_PAGE_SIZE } from "../../EmployeeDocuments.constants";
import { tagFieldNameToArray } from "../EmployerDocumentTagHelpers";

import { CellContainer, RadioContainer, TableWrapper } from "./EmployerDocumentsTable.styles";

export interface EmployerDocumentsTableProps {
    columns: ImportEmployerDocumentsColumn[];
    normalizedDocuments: EmployerNormalizedTag[];
    onSelect: (value: EmployerNormalizedTag) => void;
    onPageChange: (pageNumber: number) => void;
    activePage: number;
    value: EmployerNormalizedTag | undefined;
}

export const EmployerDocumentsTable = (props: EmployerDocumentsTableProps) => {
    const pagesCount = Math.ceil(props.normalizedDocuments.length / EMPLOYEE_DOCUMENTS_PAGE_SIZE);
    const documentsOnPage = props.normalizedDocuments.slice(
        (props.activePage - 1) * EMPLOYEE_DOCUMENTS_PAGE_SIZE,
        props.activePage * EMPLOYEE_DOCUMENTS_PAGE_SIZE
    );

    const columnsOrder = props.columns
        .map(it => it)
        .concat({
            title: "Дата отправки сведений",
            tagFieldName: "date",
        });

    const renderCellValue = (column: ImportEmployerDocumentsColumn, document: EmployerNormalizedTag) => {
        const values: string[] = tagFieldNameToArray(column.tagFieldName).map(
            tagFieldName =>
                (document.normalizedTag[tagFieldName] as string) ??
                document[tagFieldName as keyof EmployerNormalizedTag]
        );

        if (column.renderValue) {
            return column.renderValue(values.length === 1 ? (values[0] ?? "") : values);
        }

        return values.join(" ");
    };

    const getRadioValue = (tag: string | undefined, date: string | undefined) => `${tag}__${date}`;

    return (
        <div>
            <TableWrapper>
                <Table.Body>
                    <Table.Row type="header">
                        {columnsOrder.map((col, i) => (
                            <Table.Cell key={`header_${i}`}>{col.title}</Table.Cell>
                        ))}
                    </Table.Row>
                    {documentsOnPage.map((document, tagIndex) => (
                        <Table.Row
                            key={`tag_${tagIndex}`}
                            type="hover"
                            onClick={() => {
                                props.onSelect(document);
                            }}>
                            {columnsOrder.map((col, colIndex) => (
                                <Table.Cell key={col.tagFieldName}>
                                    <CellContainer>
                                        {colIndex === 0 && (
                                            <RadioContainer>
                                                <Radio
                                                    value={getRadioValue(props.value?.sourceTag, props.value?.dateIso)}
                                                    checked={
                                                        getRadioValue(props.value?.sourceTag, props.value?.dateIso) ===
                                                        getRadioValue(document.sourceTag, document.dateIso)
                                                    }
                                                />
                                            </RadioContainer>
                                        )}
                                        {renderCellValue(col, document)}
                                    </CellContainer>
                                </Table.Cell>
                            ))}
                        </Table.Row>
                    ))}
                </Table.Body>
            </TableWrapper>
            {pagesCount > 1 && (
                <Paging activePage={props.activePage} pagesCount={pagesCount} onPageChange={props.onPageChange} />
            )}
        </div>
    );
};
